export default __webpack_public_path__ + "static/media/Montserrat-Regular.b8fa52d7.ttf";